import Core from 'core/js/components/cities-select/list-layout/city-select'
export default {
  name: 'list-city-select-custom-vl',
  extends: Core,
}
